import React from 'react';
import TextField, { OutlinedTextFieldProps } from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const StyledTextField = withStyles((theme) => ({
  root: {
    width: '248px',

    [theme.breakpoints.up('md')]: {
      width: '266px',
    },

    '&.wide': {
      width: '529px',

      [theme.breakpoints.up('md')]: {
        width: '563px',
      },
    },

    '& input + fieldset': {
      borderColor: theme.palette.text.primary,
      borderRadius: '16px',
    },

    '& textarea + fieldset': {
      borderColor: theme.palette.text.primary,
      borderRadius: '16px',
      height: 'auto',
    },

    '& label': {
      color: theme.palette.text.primary,
    },
  },
}))(TextField);

const DSTextField: React.FC<OutlinedTextFieldProps> = (props) => <StyledTextField {...props} />;

export default DSTextField;
